import React from 'react';
type PESealProps = {
  className?: string;
};

/** Professional Engineer (Florida) digital badge — embossed seal, not decoration. */
export function PESeal({
  className = 'h-28 w-28'
}: PESealProps) {
  return <svg viewBox="0 0 120 120" className={className} role="img" aria-label="Licensed Professional Engineer, State of Florida" data-id="element-110" data-mp="3bnjbu69wbj4p">
      <circle cx="60" cy="60" r="57" fill="#0c1e2b" stroke="#d99a52" strokeWidth="2" data-id="element-111" data-mp="37nivuh75ezvj" />
      <circle cx="60" cy="60" r="49" fill="none" stroke="#d99a52" strokeWidth="1" data-id="element-112" data-mp="2jy7uoylvz3gv" />
      <circle cx="60" cy="60" r="37" fill="none" stroke="#3f9aa6" strokeWidth="0.8" data-id="element-113" data-mp="2ezddu27hboze" />
      <path id="pe-top" d="M60 18a42 42 0 0 1 0 84" fill="none" data-id="element-114" data-mp="2symji7y270p4" />
      <text fill="#f7f2e7" fontSize="9.5" fontFamily="Inter, sans-serif" fontWeight="600" letterSpacing="2.4" data-id="element-115" data-mp="2svqkshee07zm">
        <textPath href="#pe-top" startOffset="6%" data-id="element-116" data-mp="87vtzrk94uf8">PROFESSIONAL ENGINEER</textPath>
      </text>
      <path id="pe-bottom" d="M60 102a42 42 0 0 1 0-84" fill="none" data-id="element-117" data-mp="38svkpys1mg8" />
      <text fill="#d99a52" fontSize="9" fontFamily="Inter, sans-serif" fontWeight="600" letterSpacing="2.4" data-id="element-118" data-mp="38j6r5pgxlc4">
        <textPath href="#pe-bottom" startOffset="10%" data-id="element-119" data-mp="2kyvidbvpqo9y">STATE OF FLORIDA</textPath>
      </text>
      <text x="60" y="58" textAnchor="middle" fill="#f7f2e7" fontSize="26" fontFamily="Fraunces, serif" fontWeight="900" letterSpacing="1" data-id="element-120" data-mp="2p0h3tlmbcavr">
        P.E.
      </text>
      <text x="60" y="72" textAnchor="middle" fill="#9fb6c2" fontSize="7.5" fontFamily="Inter, sans-serif" letterSpacing="1.6" data-id="element-121" data-mp="2yvisyhgl9cyc">
        LICENSED
      </text>
      <path d="M40 80h40" stroke="#3f9aa6" strokeWidth="1" data-id="element-122" data-mp="267wg0ilh0vyt" />
    </svg>;
}